<template>
  <div class="back">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
      <div class="zlfLogo">
        <img src="../Img/login/logo-2.png" alt />
      </div>
      <div class="login">
        <div class="login_title">
          <p>Hi~欢迎来到周六福直营订货系统</p>
        </div>
        <div class="user">
          <p class="usersize">用户登录</p>
          <el-form-item prop="userName">
            <el-input
              v-model="ruleForm.userName"
              placeholder="请使用pos账号登录"
              class="data"
              @keyup.enter.native="loginuser()"
            ></el-input>
          </el-form-item>
        </div>
        <div class="messg">
          <el-col :span="24">
            <el-form-item prop="password">
              <el-input
                v-model="ruleForm.password"
                placeholder="登录密码"
                class="data"
                type="password"
                @keyup.enter.native="loginuser()"
              ></el-input>
            </el-form-item>
          </el-col>
        </div>
        <div class="verificationCodeFather">
          <el-col :span="24">
            <el-form-item prop="verificationCode">
              <el-input
                v-model.number="ruleForm.verificationCode"
                placeholder="验证码"
                class="verificationCode"
                @keyup.enter.native="loginuser()"
              ></el-input>
            </el-form-item>
          </el-col>
          <div class="verificationCode_img" @click="switchVerificationCode">
            <img :src="captcha" alt="" />
          </div>
        </div>
        <div class="loginUser" @mouseenter="mouseOver" @mouseleave="mouseLeave">
          <!-- <button>登录</button> -->
          <el-button @click="loginuser" size="mini" class="user-button_login">
            <p class="loginsize">登录</p>
          </el-button>
        </div>
      </div>
    </el-form>
    <div class="bottom" style="height:850px;"></div>
    <bottom></bottom>
  </div>
</template>

<script>
import $ from "jquery";
import bottom from "../views/bady_bottom/bottom";

export default {
  data() {
    return {
      captcha: null,
      input: "",
      ruleForm: {
        userName: "",
        password: "",
        verificationCode: "",
        T_token: "",
      },
      rules: {
        userName: [
          {
            required: true,
            message:
              "账号不能为空(如有账号不能登录问题，请联系信息部陈健，分机225)",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
        ],
        verificationCode: [
          { required: true, message: "验证码不能为空", trigger: "blur" },
        ],
      },
    };
  },
  components: {
    bottom,
  },
  mounted() {
    this.getcaptchaImg();
  },
  beforeRouteLeave(to, from, next) {
    // 设置下一个路由的 meta
    to.meta.keepAlive = false; // C 跳转到 A 时让 A 不缓存，即刷新
    next();
  },
  methods: {
    // 改变验证码
    switchVerificationCode() {
      this.getcaptchaImg();
    },
    getcaptchaImg() {
      this.$axios
        .get("/captcha/captchaImage?type=math", {
          responseType: "arraybuffer",
        })
        .then((res) => {
          this.captcha =
            "data:image/png;base64," +
            btoa(
              new Uint8Array(res.data).reduce(
                (data, byte) => data + String.fromCharCode(byte),
                ""
              )
            );
        });
    },
    mouseOver() {
      // 鼠标移入登录框触发事件
      $(".el-button").addClass("user-button");
      $(".loginsize").css("color", "#FFF");
    },
    mouseLeave() {
      // 鼠标移出登录框触发事件
      $(".el-button").removeClass("user-button");
      $(".loginsize").css("color", "#000");
    },
    // 點擊登錄
    loginuser() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          var that = this;
          var url =
            "/direct/user/login?userName=" +
            this.ruleForm.userName +
            "&passWord=" +
            this.ruleForm.password +
            "&captcha=" +
            this.ruleForm.verificationCode;
          that
            .$axios({
              url: url,
              method: "POST",
              cache: false,
              headers: {
                "X-Requested-With": "XMLHttpRequest",
                "Content-Type": "application/json",
              },
            })
            .then((res) => {
              if (res.data.code == 200) {
                that.T_token = res.data.data;
                that.getInfo();
              } else {
                this.getcaptchaImg();
                alert(res.data.msg);
              }
            })
            .catch((err) => {
              console.log(err); // 这里catch到错误timeout
            });
        }
      });
    },
    // 獲取用戶信息
    getInfo() {
      var that = this;
      var url = "/direct/user/info";
      that
        .$axios({
          url: url,
          method: "GET",
          cache: false,
          headers: {
            "T-token": that.T_token,
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$router.push({ path: "/home" });
            window.localStorage.setItem(
              "userData",
              JSON.stringify(res.data.data)
            );
          }
        })
        .catch((err) => {
          console.log(err); // 这里catch到错误timeout
        });
    },
  },
};
</script>
<style>
.login .el-input__inner {
  height: 100% !important;
  border-radius: 0 !important;
}
.login .el-input__inner::placeholder {
  padding-left: 10px;
  color: #999;
  font-size: 14px !important;
}
.el-form-item {
  margin-bottom: 0 !important;
}
.login .el-button {
  width: 388px;
  height: 56px;
  border-radius: 0 !important;
}
.user-button_login {
  background-image: url("../Img/login/loginoutinput.png") !important;
}
.user-button {
  background-image: url("../Img/login/logininput.png") !important;
}
</style>
<style scope>
.loginsize {
  font-size: 18px;
  color: #000;
}
.usersize {
  margin-bottom: 28px;
}
.data {
  width: 388px !important;
  height: 56px !important;
}
.verificationCode {
  width: 160px !important;
  height: 56px !important;
}
.zlfLogo {
  width: 126px;
  height: 58px;
  position: absolute;
  top: 78px;
  left: 0;
  right: 0;
  margin: 0 auto;
}
.login {
  width: 548px;
  position: absolute;
  top: 212px;
  /* bottom: 0px; */
  background-color: #fff;
  right: 0;
  left: 0;
  margin: auto;
}
.login_title {
  font-size: 24px;
  padding-left: 80px;
  padding-top: 62px;
  color: #000;
}
.user {
  font-size: 18px;
  color: #000;
  margin-left: 80px;
  padding-top: 42px;
}
.messg {
  font-size: 16px;
  margin-top: 34px;
  width: 388px;
  height: 56px;
  padding-left: 80px;
}
.verificationCodeFather {
  font-size: 16px;
  width: 388px;
  margin-top: 34px;
  padding-left: 80px;
  display: flex;
}
.loginUser {
  width: 388px;
  height: 56px;
  margin-left: 80px;
  margin-top: 30px;
  margin-bottom: 30px;
}
.back {
  position: absolute;
  width: 100%;
  /* overflow: scroll; */
  height: 100%;
  background: url("../Img/login/back.png");
}
.verificationCode_img img {
  width: 190px;
  height: 56px;
}
</style>

<style scope>
@media screen and (min-width: 1200px) {
}
@media screen and (min-width: 1400px) {
}
@media screen and (min-width: 1600px) {
}
@media screen and (min-width: 1920px) {
}
</style>
